<!--
@name:表格组件
@description:查询栏、表格Table、分页组件，使用见README
@author:hzw
@time:2020-12-15 15:28:36
-->
<template>
  <div class="base-table">
    <div class="lj-search-form" ref="searchForm" v-if="searchFormLayout">
      <el-row class="inline-row">
        <el-col :span="20">
          <el-form
              size="small"
              :inline="true"
              label-position="left"
              class="lj-search-box"
              ref="form">
            <el-form-item :label="`${searchBaseForm.label || '关键字'}：`" v-if="!searchFlag&&searchBaseForm.show" :prop="searchBaseForm.field">
              <el-input
                  :placeholder="`请输入${searchBaseForm.label || '关键字'}`"
                  v-model="form[searchBaseForm.field]"
              ></el-input>
            </el-form-item>
            <!--:span="data.span ? data.span : searchFormSpan"  2021.2.3 hzw -->
            <el-form-item v-if="!searchFlag" v-for="(data,iiii) in searchForms.slice(0,searchBaseForm.show?1:2)" :key="iiii" :label="data.label + '：'" :prop="data.name">
              <el-input
                  :placeholder="'请输入'+data.label"
                  v-if="data.type === 'input' || !data.type"
                  v-model="form[data.name]"
              />
              <el-select
                  v-if="data.type === 'select'"
                  @change="data.change?data.change($event):()=>{}"
                  :filterable="typeof data.filterable==='undefined'?true:data.filterable"
                  v-model="form[data.name]"
              >
                <el-option
                    :label="option.label"
                    :value="option.value"
                    v-for="(option,index) in data.options"
                    :key="index"
                />
              </el-select>
              <el-date-picker
                  :type="data.type.toLocaleLowerCase()"
                  end-placeholder="结束日期"
                  range-separator="至"
                  start-placeholder="开始日期"
                  v-if="data.type === 'dateRange' || data.type === 'date' || data.type==='datetime' || data.type==='year'"
                  v-model="form[data.name]"
                  :format="data.format || 'yyyy-MM-dd HH:mm:ss'"
                  :value-format="data.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
              ></el-date-picker>
            </el-form-item>
            <el-form-item >
              <el-button
                  @click="resetForm"
                  v-if="!searchFlag"
                  icon="lj-icon-refresh"
              >重置
              </el-button
              >
              <el-button
                  @click="searchTable"
                  v-if="!searchFlag"
                  icon="lj-icon-search"
                  type="primary"
              >搜索
              </el-button>
              <el-button
                  @click="searchFlag = !searchFlag"
                  size="small"
                  type="text"
                  v-if="searchForms.length>0"
                  class="search_more"
              >
                筛选更多
                <i :class="searchFlag?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
              </el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="4">
          <div class="right-box">
            <slot name="topButton">
            </slot>
          </div>
        </el-col>
      </el-row>
      <el-collapse-transition :duration="40" mode="out-in">
        <div v-show="searchFlag">
          <el-form
              class="lj-search-box"
              label-width="100px"
              ref="form"
              size="small"
              style="padding-bottom: 10px">
            <el-row :gutter="20"><!-- :span="searchFormSpan"-->
              <el-col :md="6" :lg="6" v-if="searchBaseForm.show">
                <el-form-item :label="`${searchBaseForm.label || '关键字'}：`" :prop="searchBaseForm.field">
                  <el-input
                      :placeholder="`请输入${searchBaseForm.label || '关键字'}`"
                      v-model="form[searchBaseForm.field]"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!--:span="data.span ? data.span : searchFormSpan"  2021.2.3 hzw -->
              <el-col
                  :key="i"
                  :lg="7"
                  :md="7"
                  v-for="(data,i) in searchForms"
              >
                <el-form-item :label="data.label + '：'" :prop="data.name">
                  <el-input
                      :placeholder="'请输入'+data.label"
                      v-if="data.type === 'input' || !data.type"
                      v-model="form[data.name]"
                  />
                  <el-select clearable
                      v-if="data.type === 'select'"
                      @change="data.change?data.change(($event)):()=>{}"
                      :filterable="typeof data.filterable==='undefined'?true:data.filterable"
                      v-model="form[data.name]"
                  >
                    <el-option
                        :key="iii"
                        :label="option.label"
                        :value="option.label==='全部'?'':option.value"
                        v-for="(option,iii) in data.options"
                    />
                  </el-select>
                  <el-date-picker
                      :type="data.type.toLocaleLowerCase()"
                      end-placeholder="结束日期"
                      range-separator="至"
                      start-placeholder="开始日期"
                      @change="dateChange($event,data)"
                      v-if="data.type === 'dateRange' || data.type === 'date' || data.type==='datetime' || data.type==='year'"
                      v-model="form[data.name]"
                      :format="data.format || 'yyyy-MM-dd HH:mm:ss'"
                      :value-format="data.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-show="searchFlag">
                <div style="text-align: center">
                  <el-button
                      @click="resetForm"
                      icon="lj-icon-refresh"
                      size="small"
                  >重置
                  </el-button
                  >
                  <el-button
                      size="small"
                      @click="searchTable"
                      icon="lj-icon-search"
                      type="primary"
                  >搜索
                  </el-button
                  >
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <div class="lj-search-form" ref="searchForm" v-if="!searchFormLayout">
      <el-row class="inline-row">
        <el-col :span="20">
          <el-form
              size="small"
              :inline="true"
              label-position="left"
              class="lj-search-box"
              ref="form">
            <el-form-item :label="`${searchBaseForm.label || '关键字'}：`" v-if="searchBaseForm.show" :prop="searchBaseForm.field">
              <el-input
                  :placeholder="`请输入${searchBaseForm.label || '关键字'}`"
                  v-model="form[searchBaseForm.field]"
              ></el-input>
            </el-form-item>
            <!--:span="data.span ? data.span : searchFormSpan"  2021.2.3 hzw -->
            <el-form-item v-for="(data,ii) in searchForms" :key="ii" :label="data.label + '：'" :prop="data.name">
              <el-input
                  :placeholder="'请输入'+data.label"
                  v-if="data.type === 'input' || !data.type"
                  v-model="form[data.name]"
              />
              <el-select
                  v-if="data.type === 'select'"
                  clearable
                  @change="data.change?data.change($event):()=>{}"
                  :filterable="typeof data.filterable==='undefined'?true:data.filterable"
                  v-model="form[data.name]"
              >
                <el-option
                    :key="ii"
                    :label="option.label"
                    :value="option.value"
                    v-for="(option,ii) in data.options"
                />
              </el-select>
              <el-date-picker
                  :type="data.type.toLocaleLowerCase()"
                  end-placeholder="结束日期"
                  range-separator="至"
                  start-placeholder="开始日期"
                  v-if="data.type === 'dateRange' || data.type === 'date' || data.type==='datetime' || data.type==='year'"
                  v-model="form[data.name]"
                  :format="data.format || 'yyyy-MM-dd HH:mm:ss'"
                  :value-format="data.valueFormat || 'yyyy-MM-dd HH:mm:ss'"
              ></el-date-picker>
            </el-form-item>
            <el-form-item v-if="!rest">
              <el-button
                  @click="resetForm"
                  icon="lj-icon-refresh"
              >重置
              </el-button
              >
              <el-button
                  @click="searchTable"
                  icon="lj-icon-search"
                  type="primary"
              >搜索
              </el-button
              >
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="4">
          <div class="right-box">
            <slot name="topButton">
            </slot>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="lj-table">
      <el-table
          ref="baseTable"
          @header-dragend="onDragend"
          v-loading="listLoading"
          :element-loading-text="loadingText"
          :data="tableList"
          :height="tableListHeight"
          :size="tableSize"
          :header-cell-style="headerStyle"
          @select="tableSelectChange"
          @select-all="tableSelectChange"
          @row-click="tableRowClick"
          border
          :empty-text="emptyText"
      >
        <el-table-column
            type="selection"
            v-if="tableMutiSelect"
            width="55"
            align="center">
        </el-table-column>
        <el-table-column label="序号" align="center" width="70px" v-if="tableSeq">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip="item.type === 'text' || !item.type?(item.tooltip || true):false"
            :fixed="item.fixed"
            v-for="(item,index) in headerColumns"
            :key="item.name+index"
            :label="item.name"
            :width="item.width || 'auto'"
            :resizable="false"
            align="center">
          <template slot-scope="scope">
          <span v-if="item.type === 'text' || !item.type" :class="{link:item.methodName}"
                @click.stop="item.methodName&&handle(item.methodName,scope.row)">
            <template v-if="item.prop.indexOf('.') < 0">
              {{
            scope.row[item.prop]&&typeof scope.row[item.prop] === 'object'&& scope.row[item.prop].text? (scope.row[item.prop].text) :
            (scope.row[item.prop] || scope.row[item.prop] === 0 ?scope.row[item.prop]:'-')
            }}
            </template>
<!--            TODO 先简便写 后期做修改-->
            <template v-else-if="item.prop.split('.').length === 2">
              {{scope.row[item.prop.split('.')[0]]?scope.row[item.prop.split('.')[0]][item.prop.split('.')[1]]:'-'}}
            </template>
            <template v-else-if="item.prop.split('.').length === 3">
              {{scope.row[item.prop.split('.')[0]] ? (scope.row[item.prop.split('.')[0]][item.prop.split('.')[1]] ?scope.row[item.prop.split('.')[0]][item.prop.split('.')[1]][item.prop.split('.')[2]]:'-'):'-'}}
            </template>
          </span>

            <el-image
                v-else-if="item.type === 'img'"
                style="height: 100px;"
                :src="scope.row[item.prop] || noImg"
                fit="contain" :preview-src-list="[scope.row[item.prop] || noImg]"></el-image>

            <slot v-else-if="item.type==='custom'" :name="item.prop" v-bind="scope.row">
            </slot>
          </template>
        </el-table-column>
        <el-table-column :fixed="tableActions.fixed" v-if="!noAction" label="操作" align="center" width="150px">
          <template slot-scope="scope">
            <el-link
                style="margin-right: 5px;"
                v-for="(item,index) in tableActions.buttons"
                :key="index"
                :underline="false"
                :icon="item.icon"
                :type="item.type || 'primary'"
                :size="item.size || 'mini'"
                :disabled="item.disabled"
                @click.stop="handle(item.methodName,scope.row)"
            >{{ item.text }}
            </el-link>
            <slot name="action" v-bind="scope.row">
            </slot>
          </template>
        </el-table-column>
        <tb-empty slot="empty" :text="emptyText"/>
      </el-table>
    </div>
    <div class="lj-pagination" style="text-align: center">
      <!--      :hide-on-single-page="tableTotal<=form[paginationConfig.pageSize]"-->
      <el-pagination
          :current-page="form[paginationConfig.page]"
          :page-size="form[paginationConfig.pageSize]"
          :total="tableTotal"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/base.css';
import noImage from './assets/noImage.png'
import TbEmpty from "@/components/paginationTable/src/tbEmpty";
import elementResizeDetectorMaker from "element-resize-detector";

export default {
  name: "ljListPage",
  components: {TbEmpty},
  props: {
    //是否loading
    listLoading: {
      type: Boolean,
      default: false
    },
    noAction:{
      type: Boolean,
      default: false
    },
    //加载展示文本
    loadingText: {
      type: String,
      default: "加载中"
    },
    //为空时展示文本
    emptyText: {
      type: String,
      default: "暂无相关数据"
    },
    //表格大小
    tableSize: {
      type: String,
      default: "mini"
    },
    //表格数据
    tableList: {
      type: Array,
      default: () => []
    },
    //表格高度，固定头部需传指定
    tableHeight: {
      type: String,
      default: null
    },
    //表头样式
    headerStyle: {
      type: Object,
      default: () => ({
        // background: '#e9eff8'
      })
    },
    //表格序号
    tableSeq: {
      type: Boolean,
      default: true
    },
    //表头列
    headerColumns: {
      type: Array,
      required: true,
      default: () => []
    },
    //当内容过长被隐藏时显示 tooltip
    columnTooltip: {
      type: Boolean,
      default: true
    },
    //表格操作
    tableActions: {
      type: Object,
      default: () => {
        return {
          fixed: false,
          buttons: []
        }
      }
    },
    //表格多选
    tableMutiSelect: {
      type: Boolean,
      default: false
    },
    //多选
    tableSelectChange: {
      type: Function,
      default: () => () => {
      }
    },
    //表格单击
    tableRowClick: {
      type: Function,
      default: () => () => {
      }
    },
    //分页当前页
    tablePageNum: {
      type: Number,
      default: 1
    },
    //分页
    tablePageSize: {
      type: Number,
      default: 10
    },
    //是否显示搜索按钮
    rest:{
     type:Boolean,
     required:false
    },
    //列表总条目
    tableTotal: {
      type: Number,
      required: true
    },
    //表格基础查询
    searchBaseForm: {
      type: Object,
      default: () => {
        return {
          show: true,
          field: 'keyword',
          label: '关键字'
        }
      }
    },
    //表格更多表单
    searchForms: {
      type: Array,
      default: () => []
    },
    //查询栏占比
    searchFormSpan: {
      type: Number,
      default: 8
    },
    //分页参数字段自定义
    paginationConfig: {
      type: Object,
      default: () => {
        return {
          page: 'pageNum',
          pageSize: 'pageSize'
        }
      }
    },
    // todo
    // filterList:{
    //
    // }
  },
  mounted(){

  },
  data() {
    let form = {};
    form[this.paginationConfig.page] = this.tablePageNum;
    form[this.paginationConfig.pageSize] = this.tablePageSize;

    if (this.searchBaseForm.show) {
      form[this.searchBaseForm.field] = "";
    }
    this.searchForms.forEach(res => {
      //时间范围需特殊处理
      if (res.type === "dateRange") {
        form[res.name] = [];
        form[res.start] = "";
        form[res.end] = "";
      } else {
        form[res.name] = "";
      }

      if (res.default) {
        form[res.name] = res.default;
      }
    })

    return {
      searchFlag: false,
      form: form,
      searchFormHeight: 50,
      noImg: noImage
    }
  },
  computed: {
    searchFormLayout() {
      let count = this.searchForms.length;
      if (this.searchBaseForm.show)
        count += 1;
      return count > 3
    },
    tableListHeight() {
      const otherHeight = 100 + 32;
      const pageHeight = 32 + 5;
      let height = this.searchFormHeight + pageHeight + otherHeight;
      let listHeight = `calc(100vh - ${height}px)`;
      return listHeight;
    },
  },
  created() {
  },
  filters: {
    // formatters(val, format) {
    //   if (format) {
    //     console.log(filterHandle)
    //     //  return this.$emit(format, val);
    //   } else return val;
    //   // if (typeof (format) === 'function') {
    //   //   return format(val)
    //   // } else return val
    // },
    //操作按钮过滤
    // actionFilter(val) {
    //   return val === "edit" ? "编辑" : (val === "see" ? "查看" : "删除")
    // },
  },
  mounted() {
    this.tableLoad();
    window.addEventListener('resize', this.onWindowResize);
    this.watchSearchFormSize();
  },
  beforeDestroy() {
    // window.removeEventListener("resize", this.onWindowResize, false);
  },
  deactivated() {
    // window.removeEventListener("resize", this.onWindowResize, false);
  },
  watch: {},
  methods: {
    watchSearchFormSize() {
      let erd = elementResizeDetectorMaker();
      erd.listenTo(this.$refs.searchForm, (element) => { // 这里的this.$refs.searchForm指定要监听的元素对象，对应的是<div ref="searchForm"></div>
        this.$nextTick(() => { // 这里填写监听改变后的操作
          this.searchFormHeight = element.offsetHeight;
        });
      });
    },
    resetForm() {
      for (const argumentsKey in this.form) {
        if (argumentsKey !== this.paginationConfig.page && argumentsKey !== this.paginationConfig.pageSize) {
          console.log(this.form,'this.form')
          this.form[argumentsKey] = "";

          let formItem = this.searchForms.find(s=>s.name===argumentsKey);
          if(formItem){
          if(formItem.default){
             this.form[argumentsKey]=formItem.default;
          }
          }
        }
      }
      this.form[this.paginationConfig.page] = 1;
      this.$refs.form.resetFields()
      this.searchTable();
    },
    handleSizeChange(value) {
      this.form[this.paginationConfig.page] = 1;
      this.form[this.paginationConfig.pageSize] = value;
      this.tableLoad();

    },
    handleCurrentChange(value) {
      this.form[this.paginationConfig.page] = value;
      this.tableLoad();
    },
    //查询
    searchTable() {
      this.form[this.paginationConfig.page] = 1;

      this.tableLoad();
    },
    //表格加载
    tableLoad() {
      this.searchForms.forEach(res => {
        //时间范围需特殊处理
        if (res.type === "dateRange") {
          if (this.form[res.name] && this.form[res.name].length > 0) {
            this.form[res.start] = this.form[res.name][0];
            this.form[res.end] = this.form[res.name][1];
          } else {
            this.form[res.start] = "";
            this.form[res.end] = "";
          }
        }
      });

      this.$emit('tableLoadMethod', this.form, this.$refs.baseTable);
    },
    handle(methodName, data) {
      try {
        if (typeof this.$parent[methodName] == 'function') {
          this.$parent[methodName](data);
        } else console.error(`${methodName}方法不存在`);
      } catch (res) {
        console.error(res);
      }
    },
    doLayout() {
      this.$refs.baseTable.doLayout();
    },
    onDragend() {
      this.doLayout();
    },
    onWindowResize() {
      if (this.$refs.baseTable) {
        this.$refs.baseTable.doLayout();
      }
    },
    setFormData(key, val) {
      this.form[key] = val;
    },
    dateChange(e, data) {
      if (data.type === 'dateRange') {
        this.form[data.start] = e[0];
        this.form[data.end] = e[1];
      }
    }
  }
}
</script>
<style lang="less">
.inline-row {
  .el-col {
    .el-form {
      .el-form-item {
        margin-bottom: 10px;
      }
    }
  }
}

.el-table {
  &.el-table--medium {
    .el-table__body {
      .el-table__row {
        &:not(first) {
          .is-center.el-table-column--selection {
            .cell {
              padding-left: 14px !important;
            }
          }
        }
      }
    }
  }
}


</style>
